module.exports = __webpack_public_path__ + "img/KrestickAddCupon.bccf5b9c.svg";